import { createAction, props } from '@ngrx/store';
import {
  IEmployeeBusinessDetailResponse,
  IEmployeeBusinessesRequest,
  IEmployeeBusinessesResponse
} from '../models/employee-business-detail.model';

export const loadEmployeeBusinesses = createAction(
  '[EmployeeDetails] Load EmployeeBusinesses',
  props<{ employeeId: string; model: IEmployeeBusinessesRequest }>()
);

export const loadEmployeeBusinessesSuccess = createAction(
  '[EmployeeDetails] Load EmployeeBusinesses Success',
  props<{ response: IEmployeeBusinessesResponse }>()
);

export const loadEmployeeBusinessesFailure = createAction(
  '[EmployeeDetails] Load EmployeeBusinesses Failure',
  props<{ error: Error | any }>()
);
